import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';

interface GLCodesTabProps {
  config: Record<string, unknown>;
  setConfig: (config: Record<string, unknown>) => void;
}

export const GLCodesTab: React.FC<GLCodesTabProps> = ({
  config,
  setConfig,
}) => {
  const updateConfig = (key: string, value: unknown) => {
    setConfig({ ...config, [key]: value });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-2 p-3 bg-muted/50 rounded-lg">
        <Info className="h-5 w-5 text-primary mt-0.5 shrink-0" />
        <p className="text-sm text-muted-foreground">
          This section is optional and can be configured later.
        </p>
      </div>

      <Card className="border-dashed">
        <CardContent className="pt-4 space-y-4">
          <div className="space-y-2">
            <Label className="text-sm">Revenue Account:</Label>
            <Input
              placeholder="e.g., 4100-PROP001-ELEC"
              value={(config.revenue_account as string) || ''}
              onChange={(e) => updateConfig('revenue_account', e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Expense Account:</Label>
            <Input
              placeholder="e.g., 5100-PROP001-ELEC"
              value={(config.expense_account as string) || ''}
              onChange={(e) => updateConfig('expense_account', e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Cost Center:</Label>
            <Input
              placeholder="e.g., CC-001"
              value={(config.cost_center as string) || ''}
              onChange={(e) => updateConfig('cost_center', e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Department Code:</Label>
            <Input
              placeholder="e.g., DEPT-UTIL"
              value={(config.department_code as string) || ''}
              onChange={(e) => updateConfig('department_code', e.target.value)}
            />
          </div>
        </CardContent>
      </Card>

    </div>
  );
};
